import React, { useEffect, useState } from 'react';
import {jwtDecode} from 'jwt-decode';
import Cookies from 'js-cookie';
import axios from 'axios';

import './Dashboard.css'; // import the CSS file

const Dashboard = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [verifyStatus, setVerifyStatus] = useState(null);
  const [loadingVerify, setLoadingVerify] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get('token');

    if (tokenFromUrl) {
      try {
        Cookies.set('samlToken', tokenFromUrl, { secure: true, sameSite: 'Strict' });
        window.history.replaceState({}, document.title, '/dashboard');
      } catch (err) {
        console.error('Failed to store token in cookies:', err);
      }
    }
    const token = Cookies.get('samlToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserInfo(decoded);
      } catch (err) {
        console.error('Invalid JWT:', err);
        Cookies.remove('samlToken');
      }
    }
  }, []);

  const handleVerifyToken = async () => {
    const token = Cookies.get('samlToken');
    setVerifyStatus(null);
    setLoadingVerify(true);
    try {
      const res = await axios.get(process.env.REACT_APP_SERVICE+'/verify-token', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVerifyStatus(res.data.message || 'Token is valid');
    } catch (err) {
      setVerifyStatus(err.response?.data?.message || 'Token verification failed');
    } finally {
      setLoadingVerify(false);
    }
  };

  if (!userInfo) return <p>Loading or unauthorized...</p>;

  return (
    <div className="container">
      <h1 className="header">SAML Login Successful</h1>
      <div className="infoBox">
        <p><strong>Email:</strong> {userInfo.email || 'N/A'}</p>
        <p><strong>NameID:</strong> {userInfo.nameID || 'N/A'}</p>
        <p><strong>First Name:</strong> {userInfo.firstName || 'N/A'}</p>
        <p><strong>Last Name:</strong> {userInfo.lastName || 'N/A'}</p>
        <p><strong>Profile ID:</strong> {userInfo.profileID || 'N/A'}</p>
      </div>

      <button
        onClick={handleVerifyToken}
        className="button"
        disabled={loadingVerify}
        style={{ backgroundColor: 'green', color: 'white'}}
      >
        {loadingVerify ? 'Verifying...' : 'Verify Token'}
      </button>

      {verifyStatus && (
        <p
          className="verifyStatus"
          style={{ color: verifyStatus.toLowerCase() === 'token is valid' ? 'green' : 'red' }}
        >
          {verifyStatus}
        </p>
      )}
    </div>
  );
};

export default Dashboard;
